<section class="top-header">
    <div class="row mb-3">
        <div class="col-md-7">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="content__title">{{ header }} </h1>
                </div>
            </div>
        </div>

        <!-- <div class="col-md-2" [formGroup]="visibilityForm">
            <select class="form-control" (change)="onChangeVisibilityGroup($event)" formControlName="visibilityGroupId">
                <option *ngFor="let visibility of visibilitieGroups" [value]="visibility.id">{{ visibility.name }}</option>
            </select>
        </div> -->

        <div class="col-md-5 text-right">
            <app-header-profile [dataUser]="dataUser"></app-header-profile>
        </div>
    </div>
</section>